<template>
  <div class="app-container">
    <!-- 主要内容区域 -->

    <div class="main-content">
      <div class="bgk-img">
        <img src="https://www.hketang.cn/_nuxt/img/course-banner.2811f9b.png" alt="" />
      </div>

      <div class="contentbox">
        <div class="right">
          <div class="buttonbox">
            <div
              class="button"
              :class="active == 1 ? 'active' : ''"
              @click="butactive(1)"
            >
              设计资讯
            </div>

            <div
              class="button"
              :class="active == 2 ? 'active' : ''"
              @click="butactive(2)"
            >
              畅谈设计
            </div>
          </div>
          <div
            class="newsList"
            v-for="(item, i) in newsList"
            :key="i"
            @click="handledetal(item)"
          >
            <img :src="item.coverUrl" alt="" />

            <div class="content">
              <div class="title">{{ item.title }}</div>
              <div class="introduce">
                {{ item.content }}
              </div>
              <div class="date">{{ item.createTime }}</div>
            </div>
          </div>
          <el-pagination
            style="text-align: right"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pagesize"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>

        <div class="left">
          <div class="titlebox">
            <div class="linebox"></div>
            <div class="title">课程推荐</div>
          </div>
          <div class="card" v-for="(item, i) in mcard" :key="i" @click="handleCourseClick(item)">
            <img :src="item.img" alt="" />

            <div style="padding: 20px">
              <p>{{ item.title }}</p>

              <p style="color: red; margin-bottom: '15px'">{{ item.price }}</p>

              <!-- <el-divider style="margin:10px"></el-divider> -->

              <div
                style="
                  display: block;
                  width: 100%;
                  margin: 0 0 10px 0;
                  border: 1px solid #dde2ee;
                "
              ></div>

              <div class="perinfo">
                <img class="headimg" :src="item.headimg" alt="" />

                <span>{{ item.pername }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getnews, courseinfo } from "@/api/index.js";
export default {
  name: "team",
  components: {},
  data() {
    return {
      active: 1,
      mcard: [],
      newsList: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
    };
  },
  created() {
    this.getnews();
    this.getRecommendCourses();
  },
  methods: {
    butactive(val) {
      this.active = val;
      this.currentPage = 1;
      this.getnews();
    },
    getnews() {
      getnews({
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        newsType: this.active,
      }).then((res) => {
        if (res.data && res.data.list) {
          this.newsList = res.data.list;
          this.total = res.data.total || 0;
        } else {
          this.newsList = [];
          this.total = 0;
        }
      }).catch(error => {
        console.error('获取新闻失败:', error);
        this.newsList = [];
        this.total = 0;
      });
    },
    getRecommendCourses() {
      courseinfo({
        pageNo: 1,
        pageSize: 3,
        typeId: "2"
      }).then((res) => {
        if (res.data && res.data.list) {
          this.mcard = res.data.list.map(item => ({
            id: item.id,
            img: item.coverUrl,
            pername: item.teacherNames && item.teacherNames[0] ? item.teacherNames[0] : '讲师',
            title: item.name,
            price: item.fee ? '￥' + item.fee : '免费',
            headimg: item.teacherAvatars && item.teacherAvatars[0] ? item.teacherAvatars[0] : 'https://web-1322480718.cos.ap-nanjing.myqcloud.com/20240807/20240807122351_esxl.jpg'
          }));
        }
      }).catch(error => {
        console.error('获取推荐课程失败:', error);
      });
    },
    handleCourseClick(course) {
      this.$store.commit("activeNavIndex", 1);
      this.$router.push({ path: "/coursedetals", query: { id: course.id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1;
      this.getnews();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getnews();
    },
    handledetal(item) {
      this.$router.push({ path: "/newsdetals", query: { id: item.id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";
  color: #333;
  overflow: hidden;
  clear: both;
  .main-content {
    overflow: visible;
    position: relative;
    background: #f5f6f9;
    .bgk-img {
      width: 100%;
      height: 210px;
      z-index: 2;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .contentbox {
      margin: 20px auto;
      width: 1250px;
      display: flex;
      justify-content: space-between;
      .right {
        background: #fff;
        width: 884px;
        margin: 0 24px 60px;
        height: fit-content;
        padding: 40px 20px;
        border-radius: 20px;
        overflow: hidden;
        .buttonbox {
          display: flex;
          margin-left: 20px; // justify-content: s;
          .button {
            // width: 156px;
            // height: 56px;
            background: #f5f6f9;
            margin: 0 24px 30px 0;
            padding: 5px 30px;
            font-size: 24px;
            color: #838a9d;
            line-height: 46px;
            border-radius: 30px;
            cursor: pointer;
          }
          .active {
            background: #d5182f;
            color: #fff;
          }
        }
        .newsList {
          display: flex;
          justify-content: space-between;
          margin: 0 0 40px;
          padding: 0 20px 24px;
          border-bottom: 1px solid rgb(221, 226, 238);
          cursor: pointer;
          img {
            width: 251px;
            height: 168px;
            border-radius: 10px;
          }
          .content {
            width: 563px;
            height: 168px;
            text-align: left;
            .title {
              color: #2d3341;
              font-size: 24px;
              margin: 0 0 10px;
            }
            .introduce {
              color: #838a9d;
              font-size: 16px;
              margin: 0 0 20px;
              line-height: 25px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
            .date {
              color: #838a9d;
              font-size: 16px;
            }
          }
        }
      }
      .left {
        .titlebox {
          display: flex;
          align-items: center;
          margin: 0 0 30px;
          .linebox {
            width: 7px;
            height: 36px;
            background: #f65f58;
            border-radius: 5px;
            margin-right: 20px;
          }

          .title {
            color: #2d3341;
            font-size: 30px;
          }
        }
        .card {
          clear: both;
          width: 287px;
          // height: 354px;
          background-color: #fff;
          border-radius: 10px;
          overflow: hidden;
          margin: 24px 0 40px 0;
          box-shadow: 0 0.125rem 0.3125rem rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: transform 0.3s ease, box-shadow 0.3s ease;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.15);
          }

          img {
            width: 287px;
            height: 185px;
          }

          p {
            font-size: 18px;
            //   width: 263px;
            margin: auto;
            text-align: left;
            margin-bottom: 20px;
          }

          .perinfo {
            display: flex;
            align-items: center;
            color: #838a9d;

            .headimg {
              width: 44px;
              height: 44px;
              border-radius: 50%;
              margin-right: 10px;
            }

            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .app-container .main-content .contentbox {
    width: auto;
    max-width: 100%;
    padding: 0 16px;
  }
  .app-container .main-content .right {
    width: 100%;
    margin: 0 0 20px 0;
    padding: 24px 12px;
    border-radius: 12px;
  }
  .app-container .main-content .left {
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 992px) {
  .app-container .main-content .contentbox {
    display: flex;
    flex-direction: column;
  }
  .app-container .main-content .right .buttonbox {
    margin-left: 0;
    flex-wrap: wrap;
  }
  .app-container .main-content .right .buttonbox .button {
    font-size: 16px;
    line-height: 28px;
    padding: 4px 14px;
  }
  .app-container .main-content .right .newsList {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 0 16px;
  }
  .app-container .main-content .right .newsList img {
    width: 100%;
    height: auto;
    margin-bottom: 12px;
  }
  .app-container .main-content .right .newsList .content {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 600px) {
  .app-container .main-content .bgk-img { height: 140px; }
  .app-container .main-content .right { padding: 16px 10px; }
  .app-container .main-content .right .newsList .title { font-size: 18px; }
  .app-container .main-content .right .newsList .introduce { font-size: 14px; }
  .app-container .main-content .right .newsList .date { font-size: 12px; }
}
</style>
